<template>
  <div style="background-color:white;padding:20px;">
    <!-- 默认地址 -->
    <el-card shadow="never" style="margin-bottom:20px;">
      <div slot="header" style="font-weight:bold;">默认跳转地址</div>
      <div style="display:flex;align-items:center;">
        <el-input v-model="defaultUrl" placeholder="例如：https://syjc.gsztkj.cn/ztkj/q/eq?sid={id}" style="max-width:600px;"></el-input>
        <el-button type="primary" size="small" style="margin-left:10px;" @click="saveDefault">保存默认地址</el-button>
      </div>
      <div style="color:#999;font-size:12px;margin-top:8px;">
        {id} 将被替换为设备ID；部门未单独配置时使用此地址
      </div>
    </el-card>

    <!-- 部门专属地址 -->
    <el-card shadow="never">
      <div slot="header" style="display:flex;justify-content:space-between;align-items:center;">
        <span style="font-weight:bold;">部门专属地址</span>
        <el-button type="primary" size="small" @click="openAdd">新增部门配置</el-button>
      </div>
      <el-table :data="deptList" border>
        <el-table-column label="序号" type="index" width="60" align="center"></el-table-column>
        <el-table-column prop="companyName" label="部门" align="center"></el-table-column>
        <el-table-column prop="jumpUrl" label="跳转地址" show-overflow-tooltip></el-table-column>
        <el-table-column label="操作" width="140" align="center">
          <template slot-scope="scope">
            <el-button type="text" size="small" @click="openEdit(scope.row)">编辑</el-button>
            <el-button type="text" size="small" style="color:#f56c6c;" @click="delDept(scope.row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
    </el-card>

    <!-- 新增/编辑部门配置弹窗 -->
    <el-dialog :title="dialogTitle" :visible.sync="dialogVisible" width="500px" :close-on-click-modal="false"
      :close-on-press-escape="false">
      <el-form label-width="80px">
        <el-form-item label="部门">
          <el-cascader v-model="form.companyCode" :options="treeData" :props="treeProps" filterable clearable
            placeholder="请选择部门" style="width:100%;"></el-cascader>
        </el-form-item>
        <el-form-item label="跳转地址">
          <el-input v-model="form.jumpUrl" placeholder="例如：https://syjc.gsztkj.cn/ztkj/q/eq?sid={id}"></el-input>
        </el-form-item>
        <div style="color:#999;font-size:12px;margin-left:80px;margin-top:-6px;">{id} 将被替换为设备ID</div>
      </el-form>
      <div slot="footer">
        <el-button size="small" @click="dialogVisible = false">取消</el-button>
        <el-button size="small" type="primary" @click="saveDept">保存</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { treeCompany, listUsageJumpConfig, saveUsageJumpConfig, deleteUsageJumpConfig } from "../../api/api";

export default {
  name: "UsageJumpConfig",
  data() {
    return {
      defaultUrl: "",
      deptList: [],
      treeData: [],
      treeProps: {
        label: "companyName",
        value: "companyCode",
        children: "zcompany",
        emitPath: false,
        checkStrictly: true,
      },
      dialogVisible: false,
      dialogTitle: "新增部门配置",
      form: {
        id: null,
        companyCode: "",
        jumpUrl: "",
      },
    };
  },
  mounted() {
    this.loadConfig();
    this.loadTree();
  },
  methods: {
    loadTree() {
      treeCompany().then((datas) => {
        let { status, data } = datas;
        if (status == 200) {
          this.treeData = this.normalizeTree(data || []);
        }
      });
    },
    // 把叶子节点的空 zcompany[] 转为 undefined，避免 el-cascader 误判为还有下一级
    normalizeTree(data) {
      for (let i = 0; i < data.length; i++) {
        if (data[i].zcompany.length < 1) {
          // 最后一级没有数据将children变成undefined
          data[i].zcompany = undefined;
        } else {
          this.normalizeTree(data[i].zcompany);
        }
      }
      return data;
    },
    loadConfig() {
      listUsageJumpConfig().then((datas) => {
        let { status, data } = datas;
        if (status == 200) {
          this.defaultUrl = "";
          this.deptList = [];
          (data || []).forEach((item) => {
            if (item.companyCode) {
              this.deptList.push(item);
            } else {
              this.defaultUrl = item.jumpUrl;
            }
          });
        }
      });
    },
    saveDefault() {
      if (!this.defaultUrl) {
        this.$message.warning("请输入默认跳转地址");
        return;
      }
      if (this.defaultUrl.indexOf("{id}") == -1) {
        this.$message.warning("跳转地址必须包含 {id} 占位符");
        return;
      }
      saveUsageJumpConfig({ companyCode: "", jumpUrl: this.defaultUrl }).then((datas) => {
        let { status, message } = datas;
        if (status == 200) {
          this.$message.success("保存成功");
          this.loadConfig();
        } else {
          this.$message.error(message || "保存失败");
        }
      });
    },
    openAdd() {
      this.dialogTitle = "新增部门配置";
      this.form = { id: null, companyCode: "", jumpUrl: "" };
      this.dialogVisible = true;
    },
    openEdit(row) {
      this.dialogTitle = "编辑部门配置";
      this.form = { id: row.id, companyCode: row.companyCode, jumpUrl: row.jumpUrl };
      this.dialogVisible = true;
    },
    saveDept() {
      if (!this.form.companyCode) {
        this.$message.warning("请选择部门");
        return;
      }
      if (!this.form.jumpUrl) {
        this.$message.warning("请输入跳转地址");
        return;
      }
      if (this.form.jumpUrl.indexOf("{id}") == -1) {
        this.$message.warning("跳转地址必须包含 {id} 占位符");
        return;
      }
      saveUsageJumpConfig({
        id: this.form.id,
        companyCode: this.form.companyCode,
        jumpUrl: this.form.jumpUrl,
      }).then((datas) => {
        let { status, message } = datas;
        if (status == 200) {
          this.$message.success("保存成功");
          this.dialogVisible = false;
          this.loadConfig();
        } else {
          this.$message.error(message || "保存失败");
        }
      });
    },
    delDept(row) {
      this.$confirm("此操作将删除该部门的跳转配置, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        deleteUsageJumpConfig(row.id).then((datas) => {
          let { status, message } = datas;
          if (status == 200) {
            this.$message.success("删除成功");
            this.loadConfig();
          } else {
            this.$message.error(message || "删除失败");
          }
        });
      }).catch(() => {});
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/views/SystemSettings/UsageJumpConfig.vue